import { render } from "./ImagesWithAnnotationSetFilter.vue?vue&type=template&id=ec0a0726&scoped=true"
import script from "./ImagesWithAnnotationSetFilter.vue?vue&type=script&lang=js"
export * from "./ImagesWithAnnotationSetFilter.vue?vue&type=script&lang=js"

import "./ImagesWithAnnotationSetFilter.vue?vue&type=style&index=0&id=ec0a0726&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec0a0726"]])

export default __exports__